import {useEffect, useContext} from 'react';

import {AppContext} from './Context';
import {withWhiteLabelContext} from '../screens/ExpertHome/WhiteLabelContextProvider';
import {withWidgetContext} from '../components/widgetComponent/widgetContextProvider';

import resellerAgencyService from '../services/restServices/resellerAgencyService';
import utilsService from '../services/utilsService';

import VIDABOO_CONSTANTS from '../config/consts';
import whiteLabelConfig from '../config/whiteLabelConfig';

const ResellerMainController = ({
  whiteLabelContext = {},
  widgetContext = {},
}) => {
  const context = useContext(AppContext);

  useEffect(() => {
    whiteLabelContext.setWhiteLabelDefaultConfig(whiteLabelConfig);
    if (!utilsService.getIsClient()) {
      fetchAndHandleWhiteLabelInfoByHostname();
    }
  }, []);

  useEffect(() => {
    if (utilsService.getIsClient()) {
      updateWhiteLabelInfoUsingWidgetPublicResellerAgencyDto();
    }
  }, [widgetContext.widgetDto?.widgetId]);

  useEffect(() => {
    if (whiteLabelContext.isAgencyInfoFetched && !utilsService.getIsClient()) {
      // Mentor/Agency/Backoffice side: set agency branding
      const faviconPhotoDto =
        utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
          whiteLabelContext.agencyPhotoDtos,
          VIDABOO_CONSTANTS.PHOTO_TYPES.FAVICON,
          VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.RESELLERAGENCY,
        )?.photoDto;

      if (faviconPhotoDto?.photoUrl) {
        utilsService.setFavicon(faviconPhotoDto.photoUrl);
      }
      utilsService.setPageTitle(whiteLabelContext.agencyName);
    }
    // Customer pages handle their own branding based on mentor/agency white label priority
  }, [whiteLabelContext.isAgencyInfoFetched]);

  const updateWhiteLabelInfoUsingWidgetPublicResellerAgencyDto = () => {
    if (!widgetContext.widgetDto?.widgetId) return;
    const publicResellerAgencyDto =
      widgetContext.widgetDto?.publicResellerAgencyDto;
    if (publicResellerAgencyDto?.resellerAgencyCtrl?.whiteLabel) {
      whiteLabelContext.updateWhiteLabelConfigByResellerAgencyCtrl(
        publicResellerAgencyDto.resellerAgencyCtrl,
      );
    } else {
      whiteLabelContext.setIsAgencyInfoFetched(true);
    }
  };

  const fetchAndHandleWhiteLabelInfoByHostname = async () => {
    if (window.location.origin === VIDABOO_CONSTANTS.APP_PAGE) {
      // If user is not logged in, set agency info as fetched because expertHomeComponent will not be mounted
      if (!context.isAuthorised) {
        whiteLabelContext.setIsAgencyInfoFetched(true);
      } else {
        // handled in expertHome after the account is fetched
      }
      return;
    }

    if (utilsService.getIsInAuthenticationPageOrBackoffice()) {
      // probably cname
      // Extract hostname and fetch reseller agency data
      const hostname = window.location.hostname;
      const response =
        await resellerAgencyService.getPublicResellerAgencyByHostname(hostname);
      if (response.status === 'success' && response.publicResellerAgencyDto) {
        if (response.publicResellerAgencyDto.resellerAgencyCtrl.whiteLabel) {
          whiteLabelContext.updateWhiteLabelConfigByResellerAgencyCtrl(
            response.publicResellerAgencyDto.resellerAgencyCtrl,
          );
        } else {
          whiteLabelContext.setIsAgencyInfoFetched(true);
        }
      } else {
        handleResellerAgencyNotFound();
        whiteLabelContext.setIsAgencyInfoFetched(true);
      }
    } else {
      handleResellerAgencyNotFound();
      whiteLabelContext.setIsAgencyInfoFetched(true);
    }
  };

  const handleResellerAgencyNotFound = () => {
    showRedirectNotificationPopUp();
  };

  const showRedirectNotificationPopUp = () => {
    context.setNotificationPopUpData({
      notificationTxt:
        'Seems like there is nothing here. You will be redirected.',
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
      closeBtnFunc: () => {
        const url =
          VIDABOO_CONSTANTS.APP_PAGE +
          window.location.pathname +
          window.location.search;
        window.location.href = url;
        context.closeNotificationPopUp();
      },
    });
    context.setShowNotificationPopUp(true);
  };

  return null;
};

export default withWhiteLabelContext(withWidgetContext(ResellerMainController));
